import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'spinner-bar',
  templateUrl: './spinner-bar.component.html',
  styleUrls: ['./spinner-bar.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule],
})
export class SpinnerBarComponent implements OnInit {
  @Input() diameter: number = 30;

  constructor() {}

  ngOnInit(): void {}
}
